import React, { useState, useContext } from "react";
import {Link} from "react-router-dom";
import AuthContext from "../../../../context/auth-context"
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import IconButton from "@material-ui/core/IconButton";
import Card from "@material-ui/core/Card";
import Collapse from "@material-ui/core/Collapse";
import DataField from "../../utils/DataField"
import {getCurrentAnalystColor, translateClientType, correctRentalStoryType, formatPhone, getStatusColor, getStatus, getStatusSiglum, time_feature, checkNested, clientAge, formatAsMoney, getReservationFormat, getRentalDaysFormat, getCurrentAnalystTextReservation} from "../../utils/utils"
import { Tooltip } from "@material-ui/core";
import CurrentAnalystDialog from "./CurrentAnalystDialog/CurrentAnalystDialog"


function ReservationCard(props) {
    
    let user_key = useContext(AuthContext).user_data.user_key

    let usedCurrentAnalyst = props.reservation.current_analyst ? {...props.reservation.current_analyst} : null

    let enableDialog = usedCurrentAnalyst != null && 
        user_key !== (usedCurrentAnalyst || {}).analyst_key ? true : false

    const [expanded, setExpanded] = useState(false);
    const [openCurrentAnalystDialog, setOpenCurrentAnalystDialog] = useState(false);

    const handleExpand = (event) => {
        event.stopPropagation();
        setExpanded(!expanded);
    };

    return (
        <Card className={["listCard", "collapse"].join(" ")}>
            <div style={{display:"flex", justifyContent: "space-between"}}>
                {["pending", "in_manual_analysis"].includes(props.reservation.fraud_status) && enableDialog ?
                <div 
                    className={["listCardItem", "link", "subtitleSize", "blueText"].join(" ")}
                    style={{flex:"1 1 180px", textAlign:"center"}}
                    onClick={() => setOpenCurrentAnalystDialog(true)}
                >
                    Reserva #{props.reservation.reservation_code}
                </div> :
                <Link 
                    className={["listCardItem", "link", "subtitleSize", "blueText"].join(" ")}
                    style={{flex:"1 1 180px", textAlign:"center"}}
                    to={"/reservation/" + props.reservation.reservation_key}
                >
                    Reserva #{props.reservation.reservation_code}
                </Link>}
                <div 
                    className={["listCardItem", "normalText", "subtitleSize"].join(" ")}
                    style={{flex:"1 1 200px", textAlign:"center"}}
                >
                    {(props.reservation.client || {}).type ? translateClientType(props.reservation.client.type) : null}
                </div>
                <div 
                    className={["listCardItem", "normalText", "subtitleSize"].join(" ")}
                    style={{flex:"1 1 200px", textAlign:"center"}}
                >
                    CPF: {checkNested(props.reservation,"client","document_number") ? props.reservation.client.document_number : "-"}
                </div>
                <div 
                    className={["listCardItem", "labelText", "subtitleSize"].join(" ")}
                    style={{flex:"1 1 200px", textAlign:"center"}}
                >
                    {time_feature(props.reservation)}
                </div>
                <div 
                    className={["listCardItem", "normalText", "normalMediumSize", "bold"].join(" ")} 
                    style={{flex:"1 1 45px", textAlign:"center", cursor: "default"}}  
                >
                    <Tooltip title={<p className="tooltipText">{getStatus(props.reservation.fraud_status)}</p>}>
                    <div className={["circle", "small"].join(" ")} style={{backgroundColor:getStatusColor(props.reservation.fraud_status)}}>
                        {getStatusSiglum(props.reservation.fraud_status)}
                    </div>
                    </Tooltip>
                </div>
                <div 
                    className={["listCardItem", "normalText", "subtitleSize"].join(" ")}
                    style={{flex:"1 1 100px", textAlign:"center"}}
                >
                    {(props.reservation.rental_store_type) ? correctRentalStoryType(props.reservation.rental_store_type) : "-"}
                </div>
                <div 
                    className={["listCardItem", "normalText", "subtitleSize"].join(" ")}
                    style={{flex:"1 1 100px", textAlign:"center"}}
                >
                    Grupo: {props.reservation.car.model_group}
                </div>
                {["pending", "in_manual_analysis"].includes(props.reservation.fraud_status) ?
                <div 
                    className={["listCardItem", "normalText", "subtitleSize"].join(" ")}
                    style={{flex:"1 1 20px", textAlign:"center"}}
                >
                    <Tooltip title={<p className="tooltipText">{getCurrentAnalystTextReservation(usedCurrentAnalyst)}</p>}>
                        <div 
                            className={["circle", "superSmall"].join(" ")} 
                            style={{backgroundColor: getCurrentAnalystColor(usedCurrentAnalyst)}} 
                        />
                    </Tooltip>
                </div> : null}
                <div>
                    <IconButton onClick={handleExpand}>
                        {expanded ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
                    </IconButton>
                </div>
            </div>
            <Collapse in={expanded} timeout="auto" unmountOnExit>
            <div className={["internalCollapse", "threeColumn"].join(" ")}>
                <DataField
                    title={"Nome"}
                    label={checkNested(props.reservation, "client", "name") ? 
                        props.reservation.client.name : "-"
                    }
                    size={"normalMediumSize"}
                    titleNoWrap={true}
                />
                <DataField
                    title={"Data de Nascimento"}
                    label={
                        checkNested(props.reservation, "client", "birthdate") ? 
                        clientAge(props.reservation.client.birthdate) : "-"
                    }
                    size={"normalMediumSize"}
                    titleNoWrap={true}
                />
                <DataField
                    title={"Loja de Retirada"}
                    label={checkNested(props.reservation, "rental_store") ? 
                        props.reservation.rental_store : "-"
                    }
                    size={"normalMediumSize"}
                    titleNoWrap={true}
                />
                <DataField
                    title={"Telefone"}
                    label={checkNested(props.reservation, "client", "phones") ? 
                        props.reservation.client.phones.length > 0 ? formatPhone(props.reservation.client.phones[0], "-") : "-" : "-"
                    }
                    size={"normalMediumSize"}
                    titleNoWrap={true}
                />
                <DataField
                    title={"Data da Reserva"}
                    label={getReservationFormat(props.reservation)}
                    size={"normalMediumSize"}
                    titleNoWrap={true}
                    display={"inline"}
                />
                <DataField
                    title={"Data de Devolução"}
                    label={getRentalDaysFormat(props.reservation)}
                    size={"normalMediumSize"}
                    titleNoWrap={true}
                />
                <DataField
                    title={"Valor Total"}
                    label={checkNested(props.reservation, "final_price") ? 
                        formatAsMoney(props.reservation.final_price, "-") : "-"
                    }
                    size={"normalMediumSize"}
                    titleNoWrap={true}
                />
            </div>
            <ObservationComponent fraud_status_events={props.reservation.fraud_status_events} />
            </Collapse>
            {enableDialog ?
            <CurrentAnalystDialog
                open={openCurrentAnalystDialog}
                onClose={() => setOpenCurrentAnalystDialog(false)}
                currentAnalyst={usedCurrentAnalyst}
                reservation_key={props.reservation.reservation_key}            
            /> : null
            }
        </Card>
    );
}

export default ReservationCard;

function ObservationComponent(props) {
  if (props.fraud_status_events == null){
    return null
  }
  else if (props.fraud_status_events[props.fraud_status_events.length - 1].observation == null){
    return null
  }
  else {
    return (
        <div style={{margin:"20px"}}>
            <DataField
                title={"Observações"}
                label={props.fraud_status_events[props.fraud_status_events.length - 1].observation}
                size={"normalMediumSize"}
                titleNoWrap={true}
            />
        </div>
    )
  }
}